import * as styles from "./Stack.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import type { StackProps } from "./Stack.types";

export function Stack({
  gap = "md",
  align = "stretch",
  className,
  ...props
}: StackProps): JSX.Element {
  return (
    <div
      data-slot="stack"
      className={clsx(styles.stack({ gap, align }), className)}
      {...props}
    />
  );
}
